import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import React from "react";

const { Panel } = Collapse;

const OtherAccordian = ({ dob, sportType, fullwidthEvent, nickname, typeOfSports, establish }) => {
  return (
    <Collapse
      bordered={false}
      style={{
        width: fullwidthEvent ? "100%" : "85%"
      }}
      defaultActiveKey={["DescriptionAccordiant"]}
      expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
      className="site-collapse-custom-collapse  sideItem">
      <Panel header="Other" key="1" className={`site-collapse-custom-panel`}>
        <p className="sideItemsText" style={{ marginLeft: "1rem" }}>
          {nickname?.length > 0 && (
            <span
              style={{
                display: "block",
                fontWeight: "600",
                maxHeight: 250,
                paddingTop: "0.5rem"
              }}>
              Nickname: {nickname}
            </span>
          )}
          {sportType && (
            <span
              style={{
                display: "block",
                fontWeight: "600",
                maxHeight: 250,
                paddingTop: "0.5rem"
              }}>
              SportType: {sportType}
            </span>
          )}

          {dob && (
            <span
              style={{
                display: "block",
                fontWeight: "600",
                maxHeight: 250,
                paddingTop: "0.5rem"
              }}>
              Date of Birth: {dob}
            </span>
          )}
          {typeOfSports && (
            <span
              style={{
                display: "block",
                fontWeight: "bold",
                maxHeight: 250,
                paddingTop: "1rem"
              }}>
              SportType: {typeOfSports}
            </span>
          )}
          {establish && (
            <span
              style={{
                display: "block",
                fontWeight: "bold",
                maxHeight: 250,
                paddingTop: "1rem"
              }}>
              Established Date: {establish}
            </span>
          )}
        </p>
      </Panel>
    </Collapse>
  );
};

export default OtherAccordian;
